import { render, staticRenderFns } from "./DeviceModalFooter.vue?vue&type=template&id=c5fa09a2&scoped=true"
import script from "./DeviceModalFooter.vue?vue&type=script&lang=js"
export * from "./DeviceModalFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fa09a2",
  null
  
)

export default component.exports